import React, {Fragment,useState, useEffect} from 'react';
import {Route} from 'react-router-dom';
import { useIdleTimer } from 'react-idle-timer'
import { withRouter } from "react-router-dom";

// DASHBOARDS

import MainPage from './LandingPage';



// Layout

import AppHeader from '../../Layout/AppHeader/';
import AppSidebar from '../../Layout/AppSidebar/';
import AppFooter from '../../Layout/AppFooter/';
import SweetAlert from 'react-bootstrap-sweetalert';
import { withAuth } from '@okta/okta-react';

const LandingPage = ({match,auth}) => {

  const timeout = 3000
  const [remaining, setRemaining] = useState(timeout)
  const [elapsed, setElapsed] = useState(0)
  const [lastActive, setLastActive] = useState(+new Date())
  const [isIdle, setIsIdle] = useState(false)
  const [showTimeOut, setShowTimeOut] = useState(false);
  const [authenticated, setAuthenticated] = useState(null);
  const [logoutTosecs, setLogoutToSecs] = useState(null);
  useEffect(() => {
    
    setRemaining(getRemainingTime())
    setLastActive(getLastActiveTime())
    setElapsed(getElapsedTime())

    setInterval(() => {
      if (JSON.parse(localStorage.getItem('okta-token-storage')).accessToken) {
      let timeToExpire = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.expiresAt - Math.round(new Date().getTime()/1000);
      let idleTime =  Math.round(new Date().getTime()/1000) - Math.round(getLastActiveTime()/1000);
     
       if (idleTime > 25*60) {
         setShowTimeOut(true);
         setLogoutToSecs((30*60) - idleTime);

       }
     
      //  if (idleTime >= 30*60) {
      //   // auth.logout('/');
      //  }
      setRemaining(getRemainingTime())
      setLastActive(getLastActiveTime())
      setElapsed(getElapsedTime())
    }}, 1000)
  }, [])

  const checkAuthentication = async () => {
    setShowTimeOut(false);
    if (logoutTosecs <= 0) {
      window.location.reload(false);
    } else {
    const userinfo = await auth.getUser(); 
    auth.isAuthenticated().then(isAuthenticated => {
      const accessToken = auth._oktaAuth.tokenManager.get('accessToken');
      if (isAuthenticated !== authenticated) {
        setAuthenticated(isAuthenticated);
      }
    });
  }
  }


  const handleOnActive = () => setIsIdle(false)
  const handleOnIdle = () => setIsIdle(true)

  const {
    reset,
    pause,
    resume,
    getRemainingTime,
    getLastActiveTime,
    getElapsedTime
  } = useIdleTimer({
    timeout,
    onActive: handleOnActive,
    onIdle: handleOnIdle
  })

  const handleReset = () => reset()
  const handlePause = () => pause()
  const handleResume = () => resume()

      return (
    <Fragment>
        <AppHeader/>
        <div className="app-main" >
            <AppSidebar/>
            <div className="app-main__outer" >
                <div className="app-main__inner" >
                    <Route path={`${match.url}/supplier/LandingPage`} component={MainPage}/>
                      
                </div>
               
            </div>
            {/* <div>
        <h1>Timeout: {timeout}ms</h1>
        <h1>Time Remaining: {remaining}</h1>
        <h1>Time Elapsed: {elapsed}</h1>
        <h1>Last Active: {lastActive}</h1>
        <h1>Idle: {isIdle.toString()}</h1>
      </div> */}


<SweetAlert
          show={showTimeOut}
          warning
          confirmBtnText="OK"
          confirmBtnBsStyle="danger"
          title={(logoutTosecs>0)?"Your session will expire in " + new Date(logoutTosecs * 1000).toISOString().substr(14, 5)  + ' Minutes': "Your session is expired" }
          onConfirm={() => checkAuthentication()}
          onCancel={() => setShowTimeOut(false)}
          focusCancelBtn
        >
          Press OK to continue
        </SweetAlert>
        </div>
        <AppFooter/>
    </Fragment>
      );
};

export default (withRouter(withAuth(LandingPage)));
